function isYesConfirmation (text) {
  return String(text || '').trim().toLowerCase() === 'yes'
}

export default {
  name: 'duplicate-topup-confirm-dialog',
  props: {
    phoneNumber: String,
    amountLabel: String
  },
  data () {
    return {
      dialog: false,
      confirmationText: ''
    }
  },
  computed: {
    canConfirm () {
      return isYesConfirmation(this.confirmationText)
    }
  },
  watch: {
    dialog (open) {
      if (!open) {
        this.resolveOpen(false)
      }
    }
  },
  methods: {
    open () {
      this.resolveOpen(false)
      this.confirmationText = ''
      this.dialog = true
      this.$nextTick(() => {
        const field = this.$refs.yesField
        if (field && field.focus) {
          field.focus()
        }
      })
      return new Promise((resolve) => {
        this._resolve = resolve
      })
    },
    confirm () {
      if (!this.canConfirm) {
        return
      }
      this.resolveOpen(true)
      this.dialog = false
    },
    cancel () {
      this.resolveOpen(false)
      this.dialog = false
    },
    resolveOpen (result) {
      if (!this._resolve) {
        return
      }
      const resolve = this._resolve
      this._resolve = null
      resolve(result)
    }
  }
}
